
<button class="ui button disabled" v-if="shopRank === 'D'"><i class="heart icon"></i>一括問合せ対象外</button>
<button class="ui button checked" v-else-if="checked && shopRank !== 'D'" @click.prevent="toggle"><i class="heart icon"></i>リストに追加済み</button>
<button class="ui button" v-else-if="!checked && shopRank !== 'D'"  @click.prevent="toggle"><i class="heart outline icon"></i>一括問合せリストに追加</button>
